export async function* asyncIterableFromArray(items) {
    for (const item of items)
        yield item;
}
//# sourceMappingURL=async-iter.js.map